import { render } from "./ProductSuggestionModal.vue?vue&type=template&id=67964027&scoped=true"
import script from "./ProductSuggestionModal.vue?vue&type=script&lang=js"
export * from "./ProductSuggestionModal.vue?vue&type=script&lang=js"

import "./ProductSuggestionModal.vue?vue&type=style&index=0&id=67964027&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67964027"]])

export default __exports__